module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-19.199b05c4.JPG";